<div id="page-container">
  <div id="content-wrap">
    <div class="fullScreen">
      <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
        (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"
        (buyPopupEvent)="shouldBuyCredits = $event"></headband>
    </div>

    <div class="flex content-evenly">
      <div>
        <img src="assets/v8te.png" id="logo">
      </div>
      <main class="w-70p flex flex-column mt-40 p-20" style="height: 100vh;">
        <div id="suspended-page-header" class="flex content-between mb-20">
          <div class="flex gap-10 align-items-center">
            <div class="arrow-container pointer" style="margin-right: 10px;" (click)="navigateArrow()">
              <img class="arrow" src="assets/arrow-left.svg">
              <p class="dark-blue text-sm" style="margin: 0;">Retour</p>
            </div>

            <div>
              <p class="bold light-blue text-xl no-margin mb-10">Gestion des accès</p>
              <p class="grey no-margin">Attribuez des profils utilisateur pour contrôler leur droits dans l'application
              </p>
            </div>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 3fr 9fr; gap: 20px;">
          <div class="radius-10 h-fit" style="border: solid 1px #E3F2FF;">
            <div class="bg-light-gray p-20 flex align-items-center gap-10" style="border-bottom: solid 1px #DCEEFF;">
              <img src="assets/square-group-silhouette-icon.svg" alt="icon silhouette" width="40px">
              <p class="light-blue no-margin bold">Profils</p>
            </div>
            <div class="p-20 flex align-items-center gap-10">
              <input type="radio" name="profileFilter" value="all" id="profile-all" (change)="filterByProfile('all')"
                checked>
              <label for="profile-all" class="bold dark-blue no-margin">Tous</label>
            </div>
            <div class="p-20 flex content-between align-items-center" style="border: solid 1px #E3F2FF;">
              <div class="flex align-items-center gap-10">
                <input type="radio" name="profileFilter" value="0" id="profile-0" (change)="filterByProfile('0')">
                <label for="profile-0" class="bold dark-blue no-margin text-sm">Ressources Humaines</label>
              </div>
              <app-custom-tag [isValidated]="true" [backgroundColor]="'#D8E8FF'" [textColor]="'#2B2D67'"
                [text]="countUserByProfile(0)"></app-custom-tag>
            </div>
            <div class="p-20 flex content-between align-items-center" style="border: solid 1px #E3F2FF;">
              <div class="flex align-items-center gap-10">
                <input type="radio" name="profileFilter" value="1" id="profile-1" (change)="filterByProfile('1')">
                <label for="profile-1" class="bold dark-blue no-margin text-sm">Bureau de vote</label>
              </div>
              <app-custom-tag [isValidated]="true" [backgroundColor]="'#CBFFD5'" [textColor]="'#2B2D67'"
                [text]="countUserByProfile(1)"></app-custom-tag>
            </div>
            <div class="p-20 flex content-between align-items-center" style="border: solid 1px #E3F2FF;">
              <div class="flex align-items-center gap-10">
                <input type="radio" name="profileFilter" value="2" id="profile-2" (change)="filterByProfile('2')">
                <label for="profile-2" class="bold dark-blue no-margin text-sm">Scrutateur</label>
              </div>
              <app-custom-tag [isValidated]="true" [backgroundColor]="'#E8EDF3'" [textColor]="'#2B2D67'"
                [text]="countUserByProfile(2)"></app-custom-tag>
            </div>
            <div class="p-20 flex content-between align-items-center" style="border: solid 1px #E3F2FF;">
              <div class="flex align-items-center gap-10">
                <input type="radio" name="profileFilter" value="3" id="profile-3" (change)="filterByProfile('3')">
                <label for="profile-3" class="bold dark-blue no-margin text-sm">Chef de projet</label>
              </div>
              <app-custom-tag [isValidated]="true" [backgroundColor]="'#FDE7F3'" [textColor]="'#2B2D67'"
                [text]="countUserByProfile(3)"></app-custom-tag>
            </div>
          </div>

          <div class="radius-10" style="border: solid 1px #E3F2FF;">
            <div class="bg-light-gray p-20 flex align-items-center gap-10" style="border-bottom: solid 1px #DCEEFF;">
              <img src="assets/square-silhouette-icon.svg" alt="icon silhouette" width="40px">
              <p class="light-blue no-margin bold">Utilisateur</p>
            </div>

            <div class="flex content-between align-items-center" style="padding: 0 20px;">
              <div>
                <p class="light-blue no-margin text-sm pointer" (click)="addUserPopup = true">+ Ajouter un utilisateur
                </p>
              </div>
              <div style="position: relative; display: inline-block;" class="w-quarter">
                <input name="search" type="text" class="pap-input dark-blue w-full" #searchInput
                  (input)="onSearch(searchInput.value)" placeholder="Rechercher..."
                  style="float: right; box-sizing: border-box; padding-right: 30px;">
                <img src="assets/magnifier-icon.svg" alt="search" width="15px"
                  style="position: absolute; right: 10px; transform: translateY(115%); pointer-events: none;">
              </div>
            </div>

            <app-roles-table [suspended]="filteredVoters" (selectedVotersChange)="setSelectedVoter($event)"
              (profileChangeRequested)="handleProfileChange($event)"
              (invitationResendRequested)="handleInvitationResend($event)"
              (deactivationRequested)="handleDeactivation($event)"
              (profileRemovalRequested)="openDeletePopup($event)"></app-roles-table>
          </div>

          <resend-invite-popup *ngIf="resendPopupVisible" [contactToInvite]="resendInviteToMail"
            (endDetailsPopup)="dismissHandleInvitationResend()"
            (sendInviteEvent)="sentInvitation($event)"></resend-invite-popup>
          <resent-invite-popup *ngIf="resentPopupVisible" [contactInvited]="resendInviteToMail"
            (endDetailsPopup)="dismissInvitationSent()" [messageAttached]="resendInviteMessage">
          </resent-invite-popup>

          <disable-popup *ngIf="disablePopupVisible" [contactToDisable]="userToDeactivate.email"
            (endDetailsPopup)="dismissDeactivationPopup()" (disableEvent)="switchUserActiveState($event)">
          </disable-popup>
          <disabled-popup *ngIf="hasBeenDisabled" [contactDisabled]="userToDeactivate.email"
            (endDetailsPopup)="dismissDisabledPopup()"></disabled-popup>

          <enable-popup *ngIf="enablePopupVisible" [contactToEnable]="userToDeactivate.email"
            (endDetailsPopup)="dismissDeactivationPopup()" (enableEvent)="switchUserActiveState($event)">
          </enable-popup>
          <enabled-popup *ngIf="hasBeenEnabled" [contactEnabled]="userToDeactivate.email"
            (endDetailsPopup)="dismissEnabledPopup()"></enabled-popup>

          <add-user-popup *ngIf="addUserPopup" (endDetailsPopup)="dismissAddUserPopup()"
            (addUserEvent)="onUserAdded($event)"></add-user-popup>
          <add-user-failed-popup *ngIf="addUserFailedPopup"
            (endDetailsPopup)="dismissAddUserFailedPopup()"></add-user-failed-popup>
          <added-user-popup *ngIf="userAddedPopup" [contactAdded]="userAddedData"
            (endDetailsPopup)="dismissUserAddedPopup()"></added-user-popup>

          <change-profile-popup *ngIf="changeProfilePopupVisible" (endDetailsPopup)="dismissProfileChangePopup()"
            [contactToUpdate]="userToChange" (changeProfileEvent)="changeUserProfile($event)"></change-profile-popup>
          <changed-profile-popup *ngIf="changeProfileConfirmationPopup"
            (endDetailsPopup)="dismissConfirmationProfileChangePopup()" [newProfile]="newProfile"
            [oldProfile]="userToChange.profile" [contactUpdated]="userToChange">
          </changed-profile-popup>

          <delete-user-popup *ngIf="deleteUserPopupVisible" [contactToDelete]="contactToDelete.email"
            (endDetailsPopup)="dismissDeleteUserPopup()"
            (deleteEvent)="handleProfileRemoval(contactToDelete)"></delete-user-popup>
        </div>
      </main>

      <div style="margin-top: 62px; margin-right: 24px;">
        <p class="no-margin dark-gray text-sm">Premier pas</p>
        <p class="no-margin dark-blue bold text-sm">À VOTRE DISPOSITION :</p>
        <div class="flex info-section gap-10 mb-10 mt-20">
          <img src="assets/guide-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour réussir un scrutin</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadGuide()">Voir nos guides</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/docs-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour tout savoir,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadDocuments()">Voir nos documents</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/support-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour toutes questions,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="contactMail()">support_client&#64;v8te.com</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>